module.exports = __webpack_public_path__ + "img/mind_icon_number_10.4c9f3862.png";